
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 19 22","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#8E8E92","fill-rule":"nonzero"}},[_c('path',{attrs:{"d":"M14.484 1.68v-.55c0-.624-.54-1.13-1.206-1.13H5.724c-.666 0-1.206.506-1.206 1.13v.55h-2.69C.819 1.68 0 2.446 0 3.392v16.892C0 21.231.82 22 1.83 22H17.17C18.18 22 19 21.232 19 20.285V3.393c0-.946-.82-1.714-1.83-1.714h-2.686zM4.517 3.392c0 .463.4.84.895.84h8.175c.495 0 .895-.376.895-.84h1.564c.62 0 1.125.472 1.125 1.054v14.819c0 .582-.504 1.054-1.125 1.054H2.953c-.62 0-1.124-.472-1.124-1.054V4.446c0-.582.503-1.053 1.124-1.053h1.564z"}}),_c('circle',{attrs:{"cx":"5.5","cy":"8","r":"1.5"}}),_c('path',{attrs:{"d":"M15.125 7h-5.25C9.394 7 9 7.444 9 8s.392 1 .876 1h5.25C15.61 9 16 8.556 16 8s-.391-1-.875-1z"}}),_c('circle',{attrs:{"cx":"5.5","cy":"12","r":"1.5"}}),_c('path',{attrs:{"d":"M15.125 11h-5.25C9.394 11 9 11.456 9 12s.392 1 .876 1h5.25c.484 0 .874-.454.874-1s-.391-1-.875-1z"}}),_c('circle',{attrs:{"cx":"5.5","cy":"16.5","r":"1.5"}}),_c('path',{attrs:{"d":"M15.125 15.5h-5.25c-.482 0-.875.456-.875 1s.392 1 .876 1h5.25c.484 0 .874-.455.874-1 0-.544-.391-1-.875-1z"}})])])
          )
        }
      }
    